<template>
  <div class="material-input" :class="{'has-error': error, 'has-addons': prefix || suffix }">
    <div class="is-flex field" :class="{'has-input': !dirty || model.length > 0}">
      <span class="flex-item" v-if="prefix">{{ prefix.replace(' ', '&nbsp;') }}</span>
      <input required
        class="flex-item is-expanded"
        v-model="model"
        :type="type"
        @blur="onBlur">
      <span class="flex-item" v-if="suffix">{{ suffix }}</span>
    </div>
    <label :style="labelLeft">{{ label }}</label>
    <div class="is-flex has-content-spaced">
      <div class="error flex-item size-65">
        <span v-if="error">{{ error }}</span>
      </div>
      <div class="placeholder flex-item">
        <span v-if="placeholder">{{ placeholder }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: String,
    label: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'text'
    },
    placeholder: String,
    prefix: String,
    suffix: String,
    error: String
  },

  data () {
    return {
      model: this.value,
      dirty: true
    }
  },

  computed: {
    labelLeft () {
      return this.prefix ? 'left: ' + (this.prefix.length * 10) + 'px' : ''
    }
  },

  watch: {
    value (val) {
      this.model = val
    },

    model (val) {
      this.dirty = false
      this.$emit('input', val)
    }
  },

  methods: {
    onBlur () {
      this.$emit('blur')
      this.dirty = this.model.length === 0
    }
  }
}
</script>

<style lang="scss">
  .material-input {
    position: relative;
    margin-bottom: 3.5rem;

    .field {
      border-bottom: 1.5px solid #e4ebf3;
      font-size: 1.8rem;
      padding-bottom: 5px;
      color: #4d4d4d;
    }

    &.has-addons {
      .field {
        padding: 0;
      }
    }

    &.has-error .field {
      border-color: #ff3860;
    }

    input {
      width: 100%;
      display: block;
      border: none;
      background: transparent;
      color: #4d4d4d;
      font-size: 1.8rem;
      font-family: 'Montserrat';
      caret-color: #4d4d4d;

      &:focus, &:active {
        outline: 0;
      }
    }

    // &.has-error input {
    //   color: #ff3860;
    // }

    label {
      color: #4d4d4d;
      font-size: 1.8rem;
      font-weight: 400;
      position: absolute;
      pointer-events: none;
      transition: all .2s ease;
      top: 0px;
    }

    // &.has-error label {
    //   color: #ff3860;
    // }

    .field.has-input ~ label {
      top: -25px;
      left: 0!important;
      font-size: 1.4rem;
      color: #4d4d4d;
    }

    // &.has-error .field.has-input ~ label {
    //   color: #ff3860;
    // }

    .placeholder {
      color: #4d4d4d;
      font-weight: 600;
      font-size: 1.2rem;
      font-style: italic;
      text-align: right;
      margin-top: 3px;
    }

    .error {
      margin-top: 3px;
      color: #ff3860;
      font-size: 1.2rem;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/MaterialInput.vue